import React, { useEffect, useState } from 'react';
const purchases = [{
  name: 'Carlos M.',
  location: 'Bogotá, Colombia'
}, {
  name: 'Javier P.',
  location: 'CDMX, México'
}, {
  name: 'Alejandro R.',
  location: 'Santiago, Chile'
}, {
  name: 'Marcelo D.',
  location: 'Lima, Perú'
}, {
  name: 'Gustavo F.',
  location: 'Quito, Ecuador'
}, {
  name: 'Daniel S.',
  location: 'Guadalajara, México'
}, {
  name: 'Pablo L.',
  location: 'Medellín, Colombia'
}, {
  name: 'Fernando G.',
  location: 'Monterrey, México'
}];
export function SocialProofPopup() {
  const [isVisible, setIsVisible] = useState(false);
  const [currentPurchase, setCurrentPurchase] = useState(purchases[0]);
  useEffect(() => {
    const initialTimer = setTimeout(() => {
      showNextPopup();
    }, 5000);
    return () => clearTimeout(initialTimer);
  }, []);
  const showNextPopup = () => {
    const randomPurchase = purchases[Math.floor(Math.random() * purchases.length)];
    setCurrentPurchase(randomPurchase);
    setIsVisible(true);
    setTimeout(() => {
      setIsVisible(false);
      const nextDelay = Math.floor(Math.random() * 10000) + 10000;
      setTimeout(showNextPopup, nextDelay);
    }, 4000);
  };
  if (!isVisible) return null;
  return <div className="fixed bottom-4 left-4 right-4 md:left-auto md:right-4 z-50 max-w-xs mx-auto md:mx-0" data-id="element-160">
      <div className="bg-brand-dark rounded-md border-2 border-brand-accent p-3 flex items-start gap-3 shadow-lg" data-id="element-161">
        <div className="bg-brand-accent text-brand-dark p-1 rounded-full shrink-0" data-id="element-162">
          <svg className="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24" data-id="element-163">
            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="3" d="M5 13l4 4L19 7" data-id="element-164"></path>
          </svg>
        </div>
        <div data-id="element-165">
          <p className="text-xs text-gray-200 leading-tight mb-1" data-id="element-166">
            <span className="font-bold text-white" data-id="element-167">{currentPurchase.name}</span>{' '}
            de {currentPurchase.location} acaba de comprar el Kit Digital ⚡
          </p>
          <p className="text-[10px] text-brand-accent font-bold" data-id="element-168">
            Hace unos minutos
          </p>
        </div>
      </div>
    </div>;
}